import React from 'react';
import {twMerge} from 'tailwind-merge';

export const EmptyPersonalWorkspaces: React.FC = () => {
  return (
    <div
      className={twMerge(
        'flex px-12 py-16 text-center',
        'w-full text-sm text-wb-text-tertiary'
      )}>
      <p>No matching workspaces</p>
    </div>
  );
};
